export default {
    common: {
        noData: '暫無數據',
        copy: '複製',
        copySuccess: '複製成功！',
        confirmText: '確認',
        cancelText: '取消',
        sendSuccess: '發送成功！',
        qrCodeDownloadApp: '掃碼下載App'
    },
    login: {
        title: '登入',
        enterUserName: '請輸入電子郵件/使用者名稱',
        enterPassword: '請輸入密碼',
        enterLogin: '登入',
        forgotPassword: '忘記密碼',
        register: '註冊帳號',
    },
    register: {
        title: '註 冊',
        enterUserName: '使用者名稱',
        enterPassword: '密碼',
        enterEmail: '電子郵件',
        enterCode: '郵箱驗證碼',
        inviteCode: '邀請碼（可選）',
        sendEmailCode: '發送驗證碼',
        enterUserNameErr: '請輸入使用者名稱',
        enterUserNameErr2: '使用者名稱由6～16位字母或數字組成',
        enterPasswordErr: '請輸入密碼',
        enterPasswordErr2: '密碼由8~18位英文字母、數字、特殊符號組成',
        enterEmailErr: '請輸入電子郵件',
        enterEmailErr2: '請輸入正確的電子郵件信箱',
        enterCodeErr: '請輸入信箱驗證碼',
        enterRegister: '註冊',
        registerSuccess: '註冊成功，即將跳轉登入頁面...',
        toLogin: '已有帳號？直接登入',
        emailCodeTip: '如果您在收件匣中未收到郵件，那可能是被誤判為垃圾郵件了，請去郵箱垃圾箱中查看。 '
    },
    forgotPassword: {
        title: '忘 記 密 碼',
        enterEmail: '電子郵件',
        enterCode: '郵箱驗證碼',
        sendEmailCode: '發送驗證碼',
        enterEmailErr: '請輸入電子郵件',
        enterEmailErr2: '請輸入正確的電子郵件信箱',
        enterCodeErr: '請輸入信箱驗證碼',
        enterPassword: '新密碼',
        enterPasswordErr: '請輸入新密碼',
        enterPasswordErr2: '密碼由8~18位英文字母、數字、特殊符號組成',
        enterBtn1: '取消',
        enterBtn2: '確認',
        forgotPasswordSuccess: '修改成功，即將跳轉登入頁面...'
    },
    layoutHeader: {
        login: '登入',
        register: '註冊',
        nav: ['行情', '平台', '公鏈', '銘文', '爆倉', '聰明錢', '多空', '大戶', '費率', '新聞', '應用'],
        navHyperliquid: 'Hyperliquid巨鯨監控',
        userNav1: '簽到',
        userNav12: '錢包明細',
        userNav2: '提幣',
        userNav13: '提幣記錄',
        userNav3: '合約檢查',
        userNav4: '邀請連結',
        userNav5: '收藏',
        userNav6: '追蹤',
        userNav7: '團隊',
        userNav8: '工具',
        userNav9: '退出',
        userNav10: '綁定API',
        userNav11: '打新機器人',
        searchPlaceholder: '地址或幣種查詢',
        historyTitle: '歷史搜尋記錄',
        searchTitle1: '合約',
        searchTitle2: '幣種',
        searchList1_1: '名稱',
        searchList1_2: '鏈上交易額',
        searchList1_3: '價格',
        searchList2_1: '名稱',
        searchList2_2: '流通數量',
        searchList2_3: '價格',
        searchNoResult: '暫無搜尋結果',
    },
    layoutTop: {
        topTitle1: '主流幣行情參考',
        topTitle2: '情緒指標',
        sentimentIndexBlock1: '情緒指數',
        sentimentIndexBlock1_1: '極度恐慌',
        sentimentIndexBlock1_2: '恐慌',
        sentimentIndexBlock1_3: '中性',
        sentimentIndexBlock1_4: '貪婪',
        sentimentIndexBlock1_5: '極度貪婪',
        sentimentIndexBlock2: 'BTC持倉多空',
        sentimentIndexBlock2_1: '看多優勢',
        sentimentIndexBlock2_2: '看空優勢',
        trend24h: '24 小時走勢',
        past24h: '過去 24 小時',
        candleSummary: 'BTC 最近 48 根 30 分鐘收盤價走勢',
        chartLoading: '正在載入走勢…',
        chartUnavailable: '走勢資料暫時未能載入',
        sentimentDetails: '查看詳情',
        sentimentUnavailable: '暫無數據',
        btcRatio: 'BTC 多空比',
        ratioShare: '多 {long}% · 空 {short}%',
        moodHistory: '歷史指數',
        moodRecentDays: '近 {count} 日',
        moodVsYesterday: '較昨日 {value}',
        moodUnchanged: '與昨日持平',
    },
    layoutSection: {
        title1: '聰明錢',
        title2: '輔助工具',
        titleMore: '更多>>',
    },
    layoutFooter: {
        appTitle: '超多應用程式下載',
        appNav1: '應用',
        appNav2: '錢包',
        appNav3: '社交',
        explain1: '免責聲明：',
        explain2: '本網站的所有內容均來自第三方平台,我們對於網站及其內容不做任何類型的保證,網站所有區塊鏈相關數據與資料僅供用戶學習及研究之用,不構成任何投資、法律等其他領域的建議和依據。您需謹慎運用相關數據及內容，並自行承擔所帶來的一切風險。強烈建議您獨自對內容進行研究、審查、分析和驗證。 ',
        copyright: '2026——最終解釋權歸 TokenTrend 所有'
    },
    coinDetails: {
        titleLabel1: '24小時漲跌幅',
        titleLabel2: '24小時最低價',
        titleLabel3: '24小時最低價',
        titleLabel4: '交易量',
        titleLabel5: '報告交易量',
        titleLabel6: '歷史最高價',
        titleLabel7: '歷史最低價',
        infoItem1: '幣種：',
        infoItem2: '官網連結：',
        infoItem3: '24H最高價：',
        infoItem4: '24H最底價：',
        infoItem5: '流通量：',
        infoItem6: '發行總量：',
        infoItem7: '最大發行量：',
        infoItem8: '上市時間：',
        infoItem9: '價格起始時間：',
        infoItem10: '白皮書連結：',
    },
    newCoinDetails: {
        titleLabel0: '直達連結：',
        titleLabel1: '流通量',
        titleLabel2: '流通率',
        titleLabel3: '發售數量',
        titleLabel4: '發行總量',
        titleLabel5: '24小時漲幅',
        titleLabel6: '最新價格',
        titleLabel7: '發售價格',
        titleLabel8: '預售時間',
        titleLabel9: '上幣平台',
        titleLabel10: '發售佔比',
        listTitle: '市場行情',
        list1: '交易平台',
        list2: '幣對',
        list3: '24H交易量',
        list4: '24H交易額($)',
        list5: '佔比',
    },
    platformDetails: {
        title: '平台詳情',
        website: '官網：',
        volumn24h: '24H交易額：',
        riseFall24h: '24H漲跌幅：',
        synopsis: '簡介',
        content1: '成立時間',
        content2: '註冊地',
        content3: 'KYC認證',
        content4: '量化接口',
        content5: '資產',
        content6: '交易對數量',
        isTrue: '是',
        isFalse: '否',
        lastLinkTitle1: '交易支持',
        lastLinkTitle2: '相關連結',
        content8: '現貨交易',
        content9: '合約交易',
        content10: '場外交易',
        content11: '法幣交易',
        title3: '相關連結',
        content12: 'Facebook',
        content13: 'Twitter',
        content14: 'Reddit',
        content15: 'Telegram',
    },
    firmOffer: {
        titleLabel0: '合約地址：',
        titleLabel1: '持幣地址數',
        titleLabel2: '獨立交易地址數',
        titleLabel3: '交易筆數',
        titleLabel4: '成交額',
        titleLabel5: '流動性',
        titleLabel6: '總市值',
        titleLabel7: '創建時間',
        titleLabel8: '總鎖倉市值',
        tabs1: '交易歷史',
        tabs2: '池子變化',
        tabs3: '持幣地址',
        tabs4: '我的倉位',
        transactionTh1: '時間',
        transactionTh2: '類型',
        transactionTh3: '數量',
        transactionTh4: '價格',
        transactionTh5: '總價值',
        transactionTh6: '用戶地址',
        transactionTh7: '交易hash',
        tag1: '買入',
        tag2: '賣出',
        tag3: '增加',
        tag4: '減少',
        poolTip: '默認顯示第一個池子數據',
        poolTh1: '時間',
        poolTh2: '類型',
        poolTh3: '數量/代幣',
        poolTh4: '總價值',
        poolTh5: '用戶地址',
        poolTh6: '交易hash',
        poolCurrent: '總持幣地址數',
        Explain1: '總持幣地址數:',
        Explain2: '前10佔比:',
        Explain3: '狙擊手數:',
        Explain4: '可疑持幣地址數:',
        positionTh1: '排名',
        positionTh2: '地址',
        positionTh3: '持有比例',
        positionTh4: '數量',
        positionTh5: '24小時變化',
        positionTh6: '區塊信息',
        financeType1: 'Top 買家',
        financeType2: 'Top 賣家',
        financeTh1buy: '淨買入',
        financeTh1sell: '淨賣出',
        financeTh2buy: '買入金額($)',
        financeTh2sell: '賣出金額($)',
        financeTh3: '用戶',
        addTrace: '確認追蹤當前地址嗎？',
        addTraceSuccess: '添加成功！',
    },
    market: {
        tabs1: '熱門',
        tabs2: '漲幅',
        tabs3: '跌幅',
        tabs4: '新幣',
        tabs5: '飆升',
        tabs6: '市值',
        tabs7: '成交額',
        popularListTh0: '序號',
        popularListTh1: '幣種',
        popularListTh2: '最新價',
        popularListTh3: '24H漲幅',
        popularListTh4: '24H交易量',
        popularListTh5: '24H成交額',
        popularListTh6: '流通市值',
        popularListTh7: '上市時間',
    },
    platform: {
        tab1: '全球交易所資產排行',
        ERGlobalRankingListTh1: '序號',
        ERGlobalRankingListTh2: '平台',
        ERGlobalRankingListTh3: '資產($)',
        ERGlobalRankingListTh4: '24H交易額($)',
        ERGlobalRankingListTh5: '24H漲跌',
        ERGlobalRankingListTh6: '官網',
    },
    publicChain: {
        tableTh1: '配對',
        tableTh2: '價格/成交額', 
        tableTh3: '漲跌幅/市值',
        tableTh4: '交易筆數',
        tableTh5: '交易地址/持幣數',
        tableTh6: '流動性/時間'
    },
    inscription: {
        typeAll: '全部',
        tableTh1: '代幣名稱',
        tableTh2: '持有人',
        tableTh3: '總交易次數',
    },
    burst: {
        title6: '清算地圖',
        currentPrice: '當前價格：',
        liquidationTip1: '累計多單清算強度',
        liquidationTip2: '累計空單清算強度',
        liquidationTip3: '10x槓桿',
        liquidationTip4: '25x槓桿',
        liquidationTip5: '50x槓桿',
        liquidationTip6: '100x槓桿',
        title1: '爆倉熱力圖',
        heatmapTop: '綜合Binance、Huobi、OKX三大交易所數據，{0}USDT爆倉最大點位在{1}附近，爆倉價值為{2}USDT，請注意資金風險',
        heatmapDetailsBtn: '詳情',
        heatmapKLine1: 'k線',
        heatmapKLine2: '清算強度',
        heatmapTip1: '價格',
        heatmapTip2: '清算強度',
        kLineTip1: '開盤價',
        kLineTip2: '收盤價',
        kLineTip3: '最高價',
        kLineTip4: '最低價',
        noLogin: '點擊右上方登錄，登陸後即可查看熱力圖',
        title2: '爆倉資料',
        topBlockH41: '4H爆倉',
        topBlockH42: '12H爆倉',
        topBlockH43: '24H爆倉',
        topBlockP1: '爆倉額度',
        topBlockP2: '多單佔比',
        title3: '24H爆倉排行',
        rankingTh1: '交易所',
        rankingTh2: '幣種',
        rankingTh3: '爆倉USD',
        rankingTh4: '多單USD',
        rankingTh5: '空單USD',
        title4: '各幣種爆倉統計',
        title5: '全網交易所爆倉佔比',
        burstStatisticsHistoryTitle: '幣種爆倉歷史統計資料',
        burstStatisticsHistoryTh1: '幣種',
        burstStatisticsHistoryTh2: '多單爆倉',
        burstStatisticsHistoryTh3: '空單爆倉',
        burstStatisticsHistoryTh4: '時間',
        heatmapDetailsTitle: '爆倉熱力圖數據',
        heatmapDetailsList1Top: '空',
        heatmapDetailsList1Bottom: '多',
        heatmapDetailsList1: '方向',
        heatmapDetailsList2: '價格',
        heatmapDetailsList3: '清算',
    },
    smartMoney: {
        typeTitle1: 'Top 100 高頻交易',
        typMsg1: '8大公鏈綜合收益/收益率排名前100',
        typeTitle2: '明星聰明錢',
        typMsg2: '全球知名人士/公鏈創辦人/知名機構地址追蹤',
        typeTitle3: '一級聰明錢',
        typMsg3: '一級市場收益率較高/較穩定的聰明錢',
        typeTitle4: '自訂聰明錢',
        typMsg4: '用戶自行新增的追蹤錢包位址',
    },
    smartMoneyTop100: {
        topTip: '綜合各大DEX近30天分析資料。餘額僅供參考！ ',
        sort: '序號',
        address: '地址',
        amountUsd: '餘額',
        floatProfit: '浮盈',
        floatProfitPercent: '浮盈率',
        profit: '盈利',
        profitPercent: '盈利率',
        collectTo: '收藏',
        collectCancel: '取消收藏',
        noLogin: '登入後可查看追蹤全球前100位收益最高的聰明錢，',
        toLogin: '去登入',
    },
    smartMoneyStar: {
        th1: '名稱：',
        th2: '地址：',
        th3: '時間：',
    },
    smartMoneyOneLevel: {
        th1: '地址：',
        th2: '時間：',
    },
    smartMoneyCustom: {
        sort: '序號',
        name: '名稱',
        address: '地址',
        time: '時間',
        addNameRules: '請輸入名稱',
        addAddressRules: '請輸入地址',
        addConfirm: '確認',
        addSuccess: '添加成功！ ',
        addBtn: '新增自訂',
        delBtn: '刪除',
        delSuccess: '刪除成功！ ',
    },
    smartMoneyDetails: {
        type1: 'DEX交易',
        queryTokenAll: '全部',
        dexAddress: '地址：',
        dexHash: '交易hash：',
        dexChainName: '鏈名稱：',
        dexTransactionAmount: '交易價值：',
        dexTrackerIn: '轉入合約：',
        dexTrackerOut: '轉出合約：',
        dexTrackerType: '交易方向：',
        dexTrackerTypeCon: '{0}{1} 兌換為 {2}{3}',
        dexTransactionTime: '交易時間：',
        type2: '普通轉帳',
        ordinaryHash: '交易hash：',
        ordinaryTime: '時間：',
        ordinaryFrom: '發送者地址：',
        ordinaryTo: '接收者地址：',
        ordinarySymbol: '幣種名稱：',
        ordinaryAmount: '轉帳數量：',
    },
    manyEmpty: {
        title1: '全球帳戶多空比',
        title2: '頂級帳戶多空比',
        title3: '頂級帳戶持倉多空比',
        progress1: '多頭：',
        progress2: '空頭：',
        tableTh1: '交易所',
        tableTh2: '多空比',
        tableTh3: '多頭佔比',
        tableTh4: '空頭佔比',
    },
    whale: {
        holdingsTitle: '灰階持倉列表',
        holdingsTitle2: '更新時間：',
        holdingsTh1: '持倉變動',
        holdingsTh1_1: '1天',
        holdingsTh1_2: '7天',
        holdingsTh1_3: '30天',
        holdingsTh2: '溢價率',
        holdingsTh3: '持倉幣數量',
        holdingsTh4: '持倉價值',
        contractTitle: '合約總持倉',
        contractTh1: '交易所',
        contractTh2: '持倉價值($)',
        contractTh3: '持倉數',
        contractTh4: '15分鐘變化',
        contractTh5: '1天變化',
        exchangeTitle: '交易所餘額清單',
        exchangeTh1: '交易所',
        exchangeTh2: '錢包數',
        exchangeTh3: '24H變化',
        exchangeTh4: '7天變化',
        exchangeTh5: '30天變化',
        statistics1: '總市值：',
        statistics2: '24小時交易量：',
        statistics3: '24小時最低價：',
        listRight1: '時間',
        listRight2: '轉出地址',
        listRight3: '轉入地址',
        listRight4: '轉帳數量',
    },
    rate: {
        newTitle: '交易所當前資金費率列表',
        newTableTh1: '幣種',
        newTableTd1: '預測費率',
        oldTableTh1: '交易所',
        oldTableTh2: '當前費率',
        oldTableTh3: '最高費率',
        oldTableTh4: '最低費率',
        oldTableTh5: '更新時間',
    },
    consult: {
        nav1: '快訊',
        nav2: '公告',
        nav3: '新聞',
        detailsTime: '時間',
        detailsBack: '返回',
        details: '詳情',
    },
    application: {
        nav1: '應用',
        nav2: '錢包',
        nav3: '社交',
        visit: '前往',
        empty: '暫無內容',
        download: '下載',
        register: '註冊'
    },
    userSignIn: {
        alreadySignIn: '已簽到{0}天',
        signInBtn: '立即簽到',
        tip1: "瀏覽平台{0}分鐘，即可領取簽到獎勵",
        tip2: '（您已瀏覽{0}分鐘{1}秒）',
        success: '簽到成功！ ',
        recordTitle: '簽到記錄',
        recordListContent: '時間：',
    },
    userSignInRecord: {
        title: '錢包明細',
        selectAll: '全部',
        typeSelect1: '簽到獎勵',
        typeSelect2: '直推獎勵',
        typeSelect3: '團隊獎勵',
        typeSelect4: '申請提現扣除',
        typeSelect5: '系統駁回增加',
        th1: '類型',
        th2: '數量',
        th3: '時間',
    },
    userWithdrawal: {
        titleTip: '提款位址必須是TRON（TRC-20）鏈的錢包位址。填寫其他鏈的錢包位址將導致永久丟失且無法恢復。 ',
        withdrawalAddress: '您的提款地址：',
        inputWithdrawalAddress: '請輸入提款地址',
        number: '數量',
        inputNumber: '請輸入數量',
        inputNumberErr: '餘額不足',
        balance: '餘額',
        actualReceipt: '實際到帳：',
        gas: '手續費：',
        tip: '最低提領{0}USDT，提現手續費{1}%。 ',
        confirm: '確定',
        explain: '網路交易需要0-2小時，網路確認不包括在內',
        submitSuccess: '提交成功'
    },
    userWithdrawalRecord: {
        title: '提幣記錄',
        list1: '地址',
        list2: '網路',
        list3: '幣種',
        list4: '數量',
        list5: '手續費',
        list6: '狀態',
        list7: '時間',
        status0: '待審核',
        status1: '透過',
        status2: '駁回',
    },
    userContractCheck: {
        enterPlaceholder: '請輸入合約地址',
        enterBtn: '檢查',
        riskAssessment: '風險評估',
        riskInspection: '風險檢查',
        checkNFT1: ['無惡意NFT', '惡意NFT'],
        checkNFT2: ['未開源', '已開源'],
        checkNFT3: ['無代理合約', '有代理合約'],
        checkNFT4: ['未驗證', '已驗證'],
        checkNFT5: ['不是著名的、值得信賴的NFT', '著名的、值得信賴的NFT'],
        checkToken1: ['不具有修改最大交易金額或最大代幣持倉的功能', '具有修改最大交易金額或最大代幣持倉的功能'],
        checkToken2: ['所有權不可以收回', '所有權可以收回'],
        checkToken3: ['合約無隱藏所有者', '合約有隱藏所有者'],
        checkToken4: ['不具有限制單一地址最大交易量或最大持倉量的功能', '具有限制單一地址最大交易量或最大持倉量的功能'],
        checkToken5: ['令牌不是蜜罐', '令牌是蜜罐'],
        checkToken6: ['代幣不可以在去中心化交易所交易', '代幣可以在去中心化交易所交易'],
        checkToken7: ['合約沒有能力鑄造代幣', '合約有能力鑄造代幣'],
        checkToken8: ['未開源', '已開源'],
        checkToken9: ['不是代理', '是代理'],
        checkToken10: ['合約所有者不可以更改代幣持有者餘額', '合約所有者可以更改代幣持有者餘額'],
        checkToken11: ['不可以為每個分配的地址設定不同的稅率', '可以為每個分配的地址設定不同的稅率'],
        checkToken12: ['合約不可以自毀', '合約可以自毀'],
        checkToken13: ['合約不具交易冷卻機制', '合約具有交易冷卻機制'],
        checkToken14: ['不可以透過代幣合約暫停交易', '可以透過代幣合約暫停交易'],
        checkToken15: ['該代幣不是著名且值得信賴的代幣', '該代幣是著名且值得信賴的代幣'],
        botToken1: '所有者地址',
        botToken2: '所有者的餘額',
        botToken3: '所有者持有代幣的百分比',
        botToken4: '供應數量',
        botNFT1: '總交易量',
        botNFT2: '持有者數',
        botNFT3: '最高價',
        botNFT4: '24小時平均價格',
        botNFT5: '24小時最低價',
    },
    userCollect: {
        title: '收藏',
        sort: '序號',
        address: '地址',
        amountUsd: '餘額',
        floatProfit: '浮盈',
        floatProfitPercent: '浮盈率',
        profit: '盈利',
        profitPercent: '盈利率',
        cancel: '取消收藏',
        cancelSuccess: '取消成功！ ',
    },
    userTrace: {
        title: '追蹤',
        th1: '序號',
        th2: '公鏈名稱',
        th3: '代幣名稱',
        th4: '地址',
        del: '刪除',
        delSuccess: '刪除成功！ ',
    },
    userTeam: {
        title: '團隊',
        topInfo1: '直推人數',
        topInfo2: '團隊人數',
        topInfoUnit: '人',
        th1: '使用者名稱:',
        th2: '註冊時間：',
    },
    userTool: {
        tool1: 'BTC公司持倉',
        tool2: '情緒指數',
        tool3: '門頭溝監控',
        tool4: '場外價格',
        tool5: '外盤資料',
        tool6: '大戶增倉',
        tool7: '大戶減倉',
        tool8: '穩定幣',
        tool9: '區塊鏈瀏覽器',
    },
    userToolCompanyHoldings: {
        title: '全球公司BTC持倉數據',
        globalDataT1: 'BTC持倉公司',
        globalDataD1: '家',
        globalDataT2: '公司總持倉',
        globalDataD2: '近7日變化：',
        globalDataT3: '持倉總價值',
        globalDataD3: '近7日變化：',
        globalDataT4: '持倉佔BTC總市值',
        globalDataD4: '7日前佔比：',
        th1: '公司名稱',
        th2: '持倉價值($)',
        th3: '佔BTC市值',
        th4: '持倉BTC',
        th5: '近7日持倉變動',
        th6: '總持倉成本',
        th7: '平均成本($)',
    },
    userToolSentimentIndex: {
        title1: '恐慌與貪婪指數',
        title1_1: 'BTC與重要主流幣的恐慌與貪婪指數',
        gauge1: '極度恐慌',
        gauge2: '恐慌',
        gauge3: '中性',
        gauge4: '貪婪',
        gauge5: '極度貪婪',
        title2: '歷史指數',
    },
    userToolMTGoxMonitor: {
        time: '更新時間：',
        title1: '門頭溝(MTGox)BTC冷錢包',
        topLabel1: '原持有BTC總量',
        topLabel1Span: '原價值',
        topLabel2: '現剩餘BTC總量',
        topLabel2Span: '現價值',
        topLabel3: '持有BTC變動量',
        title2: 'BTC冷錢包鏈上轉出記錄',
        th1: '交易時間',
        th2: '冷錢包地址',
        th3: '轉帳BTC數量',
    },
    userToolOutsidePrice: {
        th1: '代幣名稱',
        th2: '交易所',
        th3: '成交均價',
        th4: '溢價',
    },
    userToolOutsideDisk: {
        itemTitleSpan: '更新',
        itemTitle2: '開盤時間：',
        itemInfo1: '昨收',
        itemInfo2: '今開',
        itemInfo3: '今日成交量',
        itemInfo4: '今日最高',
        itemInfo5: '今日最低',
        itemInfo6: '近一年最高',
        itemInfo7: '近一年最低',
    },
    userToolLargeIncrease: {
        title: '大戶增倉',
        titleMsg: '多個或單一幣種不同的時間段，自動計算幣種在所選時間段內的漲跌幅',
        th1: '幣種',
        th2: '24H漲跌',
        th3: '24H持倉佔比',
        th4: '週持倉佔比',
        th5: '月持倉佔比',
        th6: '全球指數($)',
        th7: '前10持倉佔比',
        th8: '前20持倉佔比',
        th9: '前50持倉佔比',
        th10: '前100持倉佔比',
    },
    userToolLargeDecrease: {
        title: '大戶減倉',
        titleMsg: '多個或單一幣種不同的時間段，自動計算幣種在所選時間段內的漲跌幅',
        th1: '幣種',
        th2: '24H漲跌',
        th3: '24H持倉佔比',
        th4: '週持倉佔比',
        th5: '月持倉佔比',
        th6: '全球指數($)',
        th7: '前10持倉佔比',
        th8: '前20持倉佔比',
        th9: '前50持倉佔比',
        th10: '前100持倉佔比',
    },
    userToolStableCoin: {
        tab1: 'USDT 行情',
        UsdTopInfo1: 'USDT場外均價',
        UsdTopInfo2: '美元匯率',
        UsdTopInfo3: 'USDT溢價率',
        UsdTitleSub1: 'USDT相關指數走勢',
        UsdTitleSub2: 'USDT溢價相關走勢',
        UsdQuery1: '7天',
        UsdQuery2: '30天',
        tab2: '相關穩定幣',
        relatedTitleSub1: '穩定幣概況',
        relatedTopTh1: '幣種',
        relatedTopTh2: '場外均價($)',
        relatedTopTh3: '溢價率',
        relatedTopTh4: '當前流通量',
        relatedTopTh5: '流通市值($)',
        relatedQuery1: '30天',
        relatedQuery2: '近一年',
        relatedTitleSub2: '穩定幣流通量',
        relatedTitleSub3: '穩定幣流通量佔比',
        relatedTitleSub4: '穩定幣鏈上發行',
        relatedBottomTh1: '時間',
        relatedBottomTh2: '幣種/主網',
        relatedBottomTh3: '發行數量',
        relatedBottomTh3_1: '增發',
        relatedBottomTh3_2: '銷毀',
        relatedBottomTh4: '交易哈希',
    },
    userToolBlockChainBrowser: {
        title: '區塊鏈瀏覽器'
    },
    bindingApi: {
        bindBtn: '綁定API',
        tip: '交易所創建API要求必須綁定IP',
        listTitle: '綁定清單',
        list1: '解綁',
        list2: '可用餘額：',
        enterBourse: '選擇交易所：',
        enterNotes: '備註：',
        enterBourseErr: '請選擇交易所',
        enterApiKeyErr: '請輸入Api key',
        enterSecretKeyErr: '請輸入Secret key',
        enterPassphraseErr: '請輸入PassPhrase(OKX必填)',
        enterNotesErr: '請輸入備註',
        bindSubmit: '提交',
        bindSuccess: '綁定成功',
        unBindSuccess: '解綁成功'
    },
    hitNewRobot: {
        top1: '智慧時代，領創科技未來',
        top2: '打新機器人9月30日正式上線',
        topBtn: '遊戲規則>>',
        hitNewTitle: '交易所打新列表',
        hitSelTitle: '請選擇區塊',
        hitNewlistTh1: '代幣資訊',
        hitNewlistTh2: '代幣價格',
        hitNewlistTh3: '初始流動',
        hitNewlistTh4: '流動資金總額',
        hitNewlistTh5: '池金額',
        hitNewlistTh6: '池',
        hitNewlistTh7: '剩餘',
        hitNewlistTh8: '上市以來',
        createBtn: '創建',
        createTitle: '創建機器人',
        createLabel1: '交易所名稱：',
        createLabel2: '幣對所名稱：',
        createLabel3: '上幣時間：',
        createLabel7: '可用餘額：',
        createLabel4: '預計購買數量：',
        createLabel5: '預計購買價格：',
        createLabel6: '搶購時間：',
        createLabel4Err: '請輸入預計購買數量',
        createLabel5Err: '請輸入預計購買價格',
        createLabel6Err: '請選擇搶購時間',
        createTip: '購買價值必須>=10USDT',
        createSuccess: '創建成功！ ',
        robotTitle: '機器人列表',
        robotListStatus1: '待執行',
        robotListStatus2: '已結束',
        robotListBinanceStatus1: '掛單成功',
        robotListBinanceStatus2: '掛單失敗',
        robotList1: '執行時間：',
        robotList2: '取消機器人',
        robotList3: '幣對',
        robotList4: '價格',
        robotList5: '數量',
        robotCancel: '取消成功',
    },
    hitNewRobotRule: {
        title: '返回',
        h2_1: '覈心優勢：',
        label1_1: '高效算灋：',
        label1_2: '深度綜合：',
        label1_3: '大資料處理：',
        label1_4: '智慧策略：',
        label1_5: '安全保障：',
        label1_6: '自動化交易：',
        label1_7: '優化體驗：',
        p1_1: '內寘高效算灋，毫秒級交易決策，精准捕捉市場動態。',
        p1_2: '綜合Binance、HTX、OKX等主流交易所API，確保數據全面準確。',
        p1_3: '利用Apache Kafka與Flink科技，實時收集並處理市場數據。',
        p1_4: '結合TensorFlow或PyTorch框架，利用歷史資料與趨勢優化打新策略。',
        p1_5: '分佈式架構，多重加密技術，保障用戶數據與交易安全。',
        p1_6: '未來探索智慧合約與跨鏈科技，實現DEX自動化交易與高效資產管理。',
        p1_7: '持續優化介面與交互設計，提供直觀數據視覺化工具，提升用戶體驗。',
        h2_2: '會員陞級標準：',
        label2_1: 'v0 → v1：',
        label2_2: 'v1 → v2：',
        label2_3: 'v2 → v3：',
        label2_4: 'v3 → v4：',
        label2_5: 'v4 → v5：',
        label2_6: 'v5 → v6：',
        label2_7: 'v6 → v7：',
        p2_1: '直推3人，團隊達到100人。',
        p2_2: '直推5人，團隊達到200人。',
        p2_3: '直推5人，其中兩人達到v2。',
        p2_4: '直推5人，其中兩人達到v3。',
        p2_5: '直推5人，其中兩人達到v4。',
        p2_6: '直推5人，其中兩人達到v5。',
        p2_7: '直推5人，其中兩人達到v6。',
        h2_3: '機器人發放標準：',
        label3_1: 'V1',
        label3_2: 'V2',
        label3_3: 'V3',
        label3_4: 'V4',
        label3_5: 'V5',
        label3_6: 'V6',
        label3_7: 'V7',
        p3_1: '獲得1個機器人。',
        p3_2: '獲得3個機器人。',
        p3_3: '獲得5個機器人。',
        p3_4: '獲得6個機器人。',
        p3_5: '獲得7個機器人。',
        p3_6: '獲得9個機器人。',
        p3_7: '獲得10個機器人，並額外贈送5個，總計15個機器人。',
        h2_4: '機器人有效運行條件：',
        label4_1: '持續簽到：',
        label4_2: '啟動條件：',
        label4_3: '簽到中斷：',
        p4_1: '會員需保持每日簽到，以確保機器人有效運行。',
        p4_2: '僅連續簽到會員可啟動打新服務。',
        p4_3: '若當日漏簽，次日打新機器人將停止運行，恢復簽到後次日零點自動啟動。',
        h2_5: '總結：',
        p5: '本平臺數位貨幣打新機器人模塊，通過高效算灋與智慧策略，為會員提供自動化、高效、安全的打新服務。隨著科技的不斷進步，我們將持續優化用戶體驗，拓展更多元化的打新選擇，助力會員實現資產增值'
    },
    invite: {
        title: '邀請好友',
        info1: '邀請好友加入報名/團隊',
        info2: '有機會獲得開啟機器人機會/推廣收益',
        info3: '嗨！歡迎來到 TokenTrend 平台',
        info4: '專為幣圈新手訂製 全新工具一鍵上手',
        btn: '複製邀請連結'
    },
    hyperliquid: {
        searchPlaceholder: '輸入錢包地址查詢持倉資訊...',
        searchBtn: '查詢',
        title: '鯨魚倉位監控',
        dataCount: '共 {0} 個大戶持倉',
        long: '做多',
        short: '做空',
        cross: '全倉',
        isolated: '逐倉',
        positionValue: '倉位價值',
        positionSize: '倉位大小',
        entryPrice: '開倉價格',
        markPrice: '標記價格',
        unrealizedPnl: '未實現盈虧',
        noData: '暫無資料',
        enterAddress: '請輸入錢包地址',
        enterValidAddress: '請輸入有效的錢包地址',
        copyAddress: '複製地址',
        whale: '巨鯨',
        explorer: '瀏覽器',
        accountTotalValue: '帳戶總價值',
        perpetual: '永續合約',
        freeMarginAvailable: '可用保證金',
        withdrawable: '可提取',
        totalPositionValue: '持倉總價值',
        leverageRatio: '槓桿倍數',
        marginUsed: '已用保證金',
        usedRatio: '使用率',
        perpTotalValue: '永續持倉總價值',
        positionsCount: '{0} 個倉位',
        avgMarginUsedRatio: '平均保證金使用率',
        directionBias: '方向偏向',
        longExposure: '多頭敞口',
        shortExposure: '空頭敞口',
        positionDistribution: '倉位分佈',
        longValue: '多頭價值',
        shortValue: '空頭價值',
        roe: 'ROE',
        upnl: '未實現盈虧',
        perpPositions: '永續倉位 ({0})',
        symbol: '幣種',
        entryAvgPrice: '開倉均價',
        margin: '保證金',
        fundingCost: '資金費用',
        noPositions: '暫無持倉',
        userAddressRequired: '用戶地址不能為空',
        addressCopied: '地址已複製',
        copyFailed: '複製失敗',
        bullish: '看多',
        bearish: '看空',
        neutral: '中性'
    }
}